import type { Directive, DirectiveBinding } from 'vue';

interface ModifiedElement extends HTMLElement {
	__ClickOutsideHandler__: EventListenerOrEventListenerObject;
}

export default {
	mounted(el: ModifiedElement, binding: DirectiveBinding) {
		el.__ClickOutsideHandler__ = (event: Event): void => {
			if (!(el === event.target || el.contains(event.target as Node))) {
				binding.value(event);
			}
		};
		document.body.addEventListener('click', el.__ClickOutsideHandler__);
	},
	unmounted(el: ModifiedElement) {
		document.body.removeEventListener('click', el.__ClickOutsideHandler__);
	}
} satisfies Directive<ModifiedElement>;
